import jobsdaheimLogo from "@/images/jobsdaheim/logo-wide.png"
import sisaxLogo from "@/images/sisax/logo-standard.jpg"
import ddfLogo from "@/images/ddf/logo.png"
import jobs4iLogo from "@/images/jobs4i/logo-wide.svg"
import personalforumLogo from '@/images/personalforum/logo-wide.png'
import arztundpflegejobsLogo from '@/images/arztundpflegejobs/logo-square.png'
import { usePage } from "@inertiajs/inertia-vue3"
import { computed } from "vue"

const logos = {
  personalforum: personalforumLogo,
  jobsdaheim: jobsdaheimLogo,
  sisax: sisaxLogo,
  ddf: ddfLogo,
  jobs4i: jobs4iLogo,
  arztundpflegejobs: arztundpflegejobsLogo,
}

// For backward compatibility and use in composables
const logo = computed(() => {
  const page = usePage()
  const settings = page.props.value.settings || {}
  return logos[settings.key] || jobsdaheimLogo
})

export {
  logo,
}
